import * as tslib_1 from "tslib";
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { AppLoadingEventsEmitter } from '../../../shared/events/loading.events';
import { UsersService } from '../../../shared/services/users.service';
import { Router } from '@angular/router';
var VerifyComponent = /** @class */ (function () {
    function VerifyComponent(usersService, changeDetectorRef, appLoadingEventsEmitter, router) {
        this.usersService = usersService;
        this.changeDetectorRef = changeDetectorRef;
        this.appLoadingEventsEmitter = appLoadingEventsEmitter;
        this.router = router;
    }
    VerifyComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        this.usersService.verifyEmail(urlParams.get('code')).subscribe(function () {
            _this.usersService.getUserProfile()
                .subscribe(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.router.navigate(['dashboard'])];
                        case 1:
                            _a.sent();
                            this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                            return [2 /*return*/];
                    }
                });
            }); });
        }, function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.router.navigate(['wizard'])];
                    case 1:
                        _a.sent();
                        this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    return VerifyComponent;
}());
export { VerifyComponent };
